import styled from 'styled-components';

const Page = styled.section`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
`;

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.js